import nProgress from 'nprogress'
import { useEffect, useRef } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { useTheme } from 'styled-components'

export const NProgress = () => {
  const theme = useTheme()

  useEffect(() => {
    nProgress.configure({
      showSpinner: false,
      template: `<div class='bar' role='bar' style='background:${theme.color.background.base.brand.primary};'><div class='peg' style='box-shadow:0 0 0.625rem ${theme.color.background.base.brand.primary}, 0 0 0.3125rem ${theme.color.background.base.brand.primary};'></div></div>`,
    })
  }, [theme.color.background.base.brand.primary])

  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      // page is being restored from bfcache, stop any active progress bar
      if (event.persisted) nProgress.done()
    }
    window.addEventListener('pageshow', handlePageShow)

    return () => {
      window.removeEventListener('pageshow', handlePageShow)
    }
  }, [])

  const pathname = usePathname()
  const searchParams = useSearchParams()

  // invoke nProgress.done() on all route changes except the initial render
  const isInitialRender = useRef(true)
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false
      return
    }

    if (pathname && searchParams) {
      nProgress.done()
    }
  }, [pathname, searchParams])

  return null
}
